import { brandKitId } from 'components/Wizards/schemas/shared/brandKitId'
import { designTopic } from 'components/Wizards/schemas/shared/designTopic'
import { count } from 'components/Wizards/schemas/shared/count'
import { tone } from 'components/Wizards/schemas/shared/voiceTones'
import { StepSchema, MultiStepSchema } from 'components/Wizards/schemas/Types'
import { object, string, date, boolean, array } from 'yup'
import { meta } from '../schemaCommon'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { TimeOfDay } from './components/PostTimes/ScheduleSelector/types'
import { postLength } from 'components/Wizards/schemas/shared/postLength'
import { PostLength } from 'components/Wizards/ContentPlanning/utils'

const getMultiPostPromptSchema = ({ generationType }: { generationType: string }) =>
  object({
    topic: designTopic
      .meta({
        label: '',
        generate: false,
        generationType,
      })
      .required(),
    count: count
      .default(5)
      .oneOf([3, 5, 10, 15, 20, 30, 40])
      .meta({
        label: 'How many posts do you want?',
      })
      .required(),
    brand_kit_id: brandKitId,
    tone,
  }).meta({
    title: 'What do you want your posts to be about?',
    subtitle: 'We prefilled this prompt based on details from your BrandKit.',
  }) as StepSchema

const PostTypeSchema = object({}).meta({ title: 'What kind of posts do you want?' }) as StepSchema

const PostDetailsSchema = object({
  post_length: postLength
    .required()
    .oneOf([
      PostLength.FiveToTenWords,
      PostLength.TenToTwentyFiveWords,
      PostLength.TwentyFiveToFiftyWords,
      PostLength.FiftyToSeventyFiveWords,
      PostLength.SeventyFivetoOneHundredWords,
      PostLength.OneHudredPlusWords,
    ])
    .default(PostLength.TenToTwentyFiveWords)
    .required()
    .meta({ label: "How long should each post's caption be?", oneOfPills: true }),
  start_time: date().meta({ label: "What's the start date for the first post?" }),
  post_frequency: string().default('Post once per week').required(),
  is_custom_schedule: boolean().default(false),
}).meta({
  title: 'Refine post details',
}) as StepSchema

const PostTimesSchema = object({
  post_time: string()
    .oneOf([
      TimeOfDay.Morning,
      TimeOfDay.Afternoon,
      TimeOfDay.Evening,
      TimeOfDay.Night,
      TimeOfDay.Random,
      TimeOfDay.Custom,
    ])
    .default(TimeOfDay.Morning),
  custom_schedule_data: object({
    selectedDays: array().of(string()).default([]),
    dayTimeSelections: object().default({}),
  }).nullable(),
}).meta({ title: 'Post Times' }) as StepSchema

const PostPreviewSchema = object({}).meta({
  title: 'Review your posts',
  subtitle: 'Here are the posts we generated for you',
}) as StepSchema

export const FlowISchema = ({ generationType }: { generationType: string }) =>
  ({
    meta,
    steps: [
      getMultiPostPromptSchema({ generationType }),
      PostTypeSchema,
      PostDetailsSchema,
      PostTimesSchema,
      PostPreviewSchema,
    ],
  } as MultiStepSchema<GenerationType>)
